// extracted by mini-css-extract-plugin
export default {"container":"PreviewBaseItem_container__lv4IC"};